import {required as _required} from '@vuelidate/validators'
import {helpers} from '@vuelidate/validators'


export const required = helpers.withMessage('Поле обязательно к заполнению', _required)
